import React, { Component } from 'react';

import './Avatar.css';

export default class Avatar extends Component {
    constructor(props, context) {
        super(props, context);

    }

    render() {
        const { text, style } = this.props
        return (
            <div className="avatar-hq" style={style}>
                {text.charAt(0)}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Avatar.jsx